import React from "react";
import { Err } from "../styles";

export function ErrorMessage(type, errors) {
  switch (type) {
    case 'dobEmpty' : 
      return <Err>Please enter the date of birth</Err>;
    case 'dob' : 
      return <Err>Please enter the date of birth</Err>;
    case "emailType":
      return <Err>Please enter email type</Err>;
    case "emailId":
      if (errors === "format") {
        return <Err>Email address should follow the format x@x.x</Err>;
      }
      return <Err>Please enter email address.</Err>;
    case "phoneType":
      return <Err>Please enter phone type</Err>;
    case "phones":
      return <Err>Please enter phone number</Err>;
    case "addressType":
      return <Err>Please specify address type</Err>;
    case "line1":
      return <Err>Please enter address</Err>;
    case "city":
      if (errors === "length") {
        return <Err>City name is too short</Err>;
      }
      return <Err>Please enter city</Err>;
    case "state":
      if (errors === "length") {
        return <Err>State name is too short</Err>;
      }
      return <Err>Please enter state</Err>;
    case "zipcode":
      if (errors === "length") {
        return <Err>The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.</Err>;
      }
      return <Err>Please enter zip code.</Err>;
    case "country":
      return <Err>Please specify country</Err>;
    case "name":
      return <Err>Please enter contributor.</Err>;
    case "relationshipType":
      return <Err>Please enter relation type.</Err>;
    case "firstname":
      if (errors === "length") {
        return <Err>First name is too short</Err>;
      }
      return <Err>Please enter first name</Err>;
    case "lastname":
      if (errors === "length") {
        return <Err>Last name is too short</Err>;
      }
      return <Err>Please enter last name</Err>;
    case "confirmSSN":
      if (errors === "length") {
        return <Err>Social security numbers do not match</Err>;
      }
      return <Err>SSN/PIN do not match.</Err>;
    case "gender":
      return <Err>Please select gender.</Err>;
    case "ssn":
      if (errors === "length") {
        return (
          <Err>Last four digits of SSN or PIN must be four characters in length.</Err>
        );
      }
      return (
        <Err>
          Please enter your social security number.
        </Err>
      );
    default:
      break;
  }
}
